import axios from "axios";
import { ehDispositivoMobile, ehErroDaApi } from "../../functions";
import { Redirecionar } from "../../functions/Redirecionar";

export class ApiException extends Error {

    public readonly message: string = '';

    public readonly status: 0 | 400 | 401 | 404 | 409 | 500 = 0;

    constructor(error: any, mensagemPersonalizada: string) {

        super();

        if (axios.isAxiosError(error)) {

            const resposta = error.response;

            if (
                resposta?.status === 400
                || resposta?.status === 404
                || resposta?.status === 409
                || resposta?.status === 500
            ) {
                if(ehErroDaApi(resposta.data)) {
                    this.message = resposta.data.Detalhes;
                    this.status = resposta.status;
                } 
                else {
                   this.message =  mensagemPersonalizada;
                }
            } else if(resposta?.status === 401) {

                if(ehDispositivoMobile()) {
                    this.message = 'Sua sessão expirou! Efetue o login novamente para continuar utilizando o aplicativo. (#401)';

                    this.status = resposta.status;
                }
                else {
                    Redirecionar.paraLogin();
                }
            } else if(error.message.includes("Network Error")) {
                this.message = 'Não possível conectar-se com o servidor. Por favor, verifique sua conexão com a internet!';

                this.status = 0;
            }
            else
                this.message = mensagemPersonalizada;
        }
        else
            this.message = mensagemPersonalizada;
    }

}